module.exports = __webpack_public_path__ + "media/images/pic/workshops/familiada-007b6c76f0d0190dd7f8ff288372fb09.jpeg";